<template>
    <div>
        <div id="audit-flow" class="muven-card"></div>
    </div>
</template>

<script>
import BpmnJS from 'bpmn-js'
import {AuditInstanceFlowModel} from '@/audit/models/AuditInstanceFlowModel'

export default {
    name: 'AuditInstanceFlowCmp',
    props: {
        auditFlow: {
            type: AuditInstanceFlowModel,
            default: new AuditInstanceFlowModel(),
        },
    },
    mounted() {
        this.initBpmn()
    },
    methods: {
        initBpmn() {
            const viewer = new BpmnJS({
                container: '#audit-flow'
            })

            viewer.importXML(this.auditFlow.xml, (err) => {
                if (err) {
                    throw err
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
#audit-flow {
    height: 100vh;

    // O bpmn-js desenha o diagrama em SVG com traco preto fixo; no escuro ele e invertido
    ::v-deep .djs-container svg {
        filter: var(--diagram-filter);
    }
}
</style>